import { ListBase } from 'react-admin';
import { ActivityLogIterator } from './ActivityLogIterator';
import { AntennaId } from '@wwf/sdk';
import { ActivityLogContextValue } from './types';

type AntennaActivityLogProps = {
    antennaId?: AntennaId;
    pageSize?: number;
    context?: ActivityLogContextValue;
};

export function AntennaActivityLog({
    antennaId,
    pageSize = 25,
    context = 'all',
}: AntennaActivityLogProps) {
    return (
        <ListBase
            resource="activityLog"
            filter={antennaId ? { antennaId } : undefined}
            perPage={pageSize}
            sort={{ field: 'activityDate', order: 'DESC' }}
        >
            <ActivityLogIterator context={context} />
        </ListBase>
    );
}
